<template>
  <date-range-picker
    v-model="value"
    :opens="opens"
    :auto-apply="true"
    :ranges="false"
    :locale-data="localeData"
    @update="update"
    :class="{ dark: isDarkMode }"
  ></date-range-picker>
</template>

<script>
export default {
  props: {
    startDate: {
      default: '',
    },
    endDate: {
      default: '',
    },
    opens: {
      type: String,
      default: 'right',
    }
  },
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    dateRange: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.value = val;
      },
    }
  },
  data() {
    return {
      localeData: {
        format: "dd/mm/yyyy",
        separator: " - ",
      },
      value: {
        startDate: this.startDate,
        endDate: this.endDate,
      }
    };
  },
  methods: {
    update() {
      this.$emit("update", this.dateRange);
    },
  },
};
</script>

<style lang="scss">
.daterangepicker.opensright {
  left: 0 !important;
  right: auto;
  transition: none;
}
.daterangepicker.opensleft {
  right: 0 !important;
  left: auto;
  transition: none;
}

.daterangepicker {
  > td.today.active.in-range.start-date,
  td.active.in-range.start-date,
  > td.today.active.in-range.end-date,
  td.active.in-range.end-date {
    background-color: var(--apio-purple) !important;
  }
}

.daterangepicker td.in-range {
  background-color: var(--apio-shade-5) !important;
}

.form-control.reportrange-text {
  background: #fff;
  cursor: pointer;
  padding: 15px 16px;
  border: 1px solid var(--apio-shade-4) !important;
  width: 100%;
  height: 48px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px !important;
  font-size: var(--font-paragraph-2-size);
}

.dark {
  .daterangepicker,
  .calendars-container {
    border: 1px solid white !important;
    border-radius: 4px;
  }

  .calendar-table,
  .calendar-table table.table-condensed {
    background: var(--apio-shade-2) !important;
    border: 1px solid var(--apio-shade-2) !important;
  }
  .daterangepicker,
  .calender-table {
    background-color: var(--apio-shade-2);
    border-color: var(--apio-shade-2);
  }

  .daterangepicker .calendar-table th {
    background: var(--apio-shade-2);
  }

  .daterangepicker .calendar-table td {
    background: var(--apio-shade-2);
  }

  .reportrange-text {
    background: var(--apio-shade-2) !important;
    border-radius: 4px !important;
  }
}
</style>